<template>
  <div class="registerCardStyle">
    <UserBase :loginLink="false" maxWidth="500">
      <template #default>
        <v-form ref="form">
          <v-row
            no-gutters
            class="py-3"
            justify="center"
            align-content="center"
          >
            <v-col cols="11">
              <p class="primary--text text-center font-weight-bold text-h6">
                {{ $t('common.input_inquiry') }}
              </p>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="pt-3"
            justify="center"
            align-content="center"
          >
            <v-col cols="11">
              <span class="font-weight-bold mr-2 header-color">
                {{ $t('common.common_contact-name') }}
              </span>
              <RequiredLabel />
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="py-2"
            justify="center"
            align-content="center"
          >
            <v-col cols="11">
              <v-text-field
                v-model="contactInfo.name"
                :placeholder="contactFormPlaceholder"
                outlined
                dense
                hide-details
                height="36"
                :rules="[required]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="pt-3"
            justify="center"
            align-content="center"
          >
            <v-col cols="11">
              <span class="font-weight-bold mr-2 header-color">{{
                $t('common.input_mailaddress')
              }}</span>
              <RequiredLabel />
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="py-2"
            justify="center"
            align-content="center"
          >
            <v-col cols="11">
              <v-text-field
                v-model="contactInfo.mail"
                :placeholder="contactFormPlaceholder"
                outlined
                dense
                hide-details
                height="36"
                :rules="[required]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="pt-3"
            justify="center"
            align-content="center"
          >
            <v-col cols="11">
              <span class="font-weight-bold mr-2 header-color">{{
                $t('common.common_contents-of-inquiry')
              }}</span>
              <RequiredLabel />
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="py-2"
            justify="center"
            align-content="center"
          >
            <v-col cols="11">
              <v-textarea
                outlined
                v-model="contactInfo.content"
                :placeholder="contactFormPlaceholder"
                hide-details
                :rules="[required]"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row no-gutters justify="center" align-content="center">
            <v-col cols="11" class="py-5">
              <NormalButton
                :text="buttonText"
                height="50px"
                textSize="16px"
                @click="send"
                :disabled="!isFormFilled"
              />
            </v-col>
          </v-row>
        </v-form>
      </template>
    </UserBase>
  </div>
</template>
<script>
import { UserBase } from '@/components/layouts'
import { NormalButton } from '@/components/items'
import RequiredLabel from '@/components/items/Labels/RequiredLabel'
import { mapActions, mapGetters } from 'vuex'
import { i18n } from '@/main'

export default {
  components: {
    UserBase,
    NormalButton,
    RequiredLabel
  },
  data: () => {
    return {
      contactInfo: {
        name: '',
        mail: '',
        content: ''
      },
      required: (value) => !!value,
      contactFormPlaceholder: i18n.tc('common.input_input_1'),
      buttonText: i18n.tc('common.input_order-send')
    }
  },
  methods: {
    ...mapActions('Inquiry', ['postInquiry']),
    async send() {
      if (this.$refs.form.validate()) {
        const isSuccess = await this.postInquiry({
          name: this.contactInfo.name,
          email: this.contactInfo.mail,
          body: this.contactInfo.content
        })
        if (!isSuccess) return
        this.$router.replace('/contact/success')
      }
    }
  },
  computed: {
    isFormFilled() {
      return (
        this.contactInfo.name !== '' &&
        this.contactInfo.mail &&
        this.contactInfo.content
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.registerCardStyle {
  .header-color {
    color: #333;
  }
  .terms {
    font-size: 12px !important;
  }
}
</style>
